<div class="mv-context-menu-divider"></div>

<style lang="less">
    .mv-context-menu-divider {
        width: 100%;
        margin: 3px 0;
        border-bottom: 1px solid var(--viewer-default-border);
    }
</style>